const getHostFlags = () => {
  const host = window.location.hostname;
  return {
    host,
    isAmazon: host.startsWith("amazon."),
    isDevOrRoovee: host.startsWith("dev.") || host.startsWith("roovee."),
  };
};

export default getHostFlags;
